// Pure refund / replacement / return / reship helpers. No Firebase.
import { suggestReshipCouriers } from './reship';

// Issue types that should expose the refund/replacement/return section.
export const RR_ISSUE_TYPES = new Set([
    'Refund Pending', 'Refund Issued',
    'Replacement Required', 'Return Pickup Required', 'Reship Required',
    'Wrong Shipment', 'Paid Extra', 'Wrong Amount Paid',
    'Product Not Delivered',
    'Delivered Status but Product Not Received', 'Delivered but Not Received',
    'Long Pending Delivery',
]);

export const isRefundReplacementIssue = (issueType) => RR_ISSUE_TYPES.has(issueType);

export const REFUND_STATUSES = ['pending', 'approved', 'issued', 'rejected'];

// Standard refund reasons (drives the reason dropdown; 'Other' opens free text).
export const REFUND_REASONS = [
    'Quality Issue',
    'Skin Allergy',
    'Extra Money Credited',
    'Product Not Delivered',
    'Wrong Amount Paid',
    'Other',
];

// Roles allowed to APPROVE (or reject) a refund. Everyone else can only
// request approval — manager-or-higher sign-off is mandatory for payouts.
export const REFUND_APPROVER_ROLES = new Set(['manager', 'super_admin', 'admin', 'director']);
export const canApproveRefund = (role) => REFUND_APPROVER_ROLES.has(String(role || '').toLowerCase());
export const REPLACEMENT_STATUSES = ['pending', 'approved', 'packed', 'shipped', 'delivered', 'rejected'];
export const PICKUP_STATUSES = ['pending', 'scheduled', 'picked_up', 'failed', 'cancelled'];

/**
 * Reship guidance: warn (not block) against reusing the courier that failed.
 * @returns {{ excluded, suggested, warning, message }}
 */
export const reshipGuidance = (oldCourier, available) => {
    const g = suggestReshipCouriers(oldCourier, available);
    const message = g.warning
        ? `Previous shipment used ${g.excluded}. Use ${g.suggested.slice(0, 2).join(' or ')} for reship.`
        : null;
    return { ...g, message };
};
